import type { Locale } from "@/lib/i18n";
import { pl, type WWindowBannerTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wWindowBannerTranslations: Record<Locale, WWindowBannerTranslations> = {
  pl,
  en,
  de,
};

export type { WWindowBannerTranslations };
